<template>
  <div>
    <el-dialog title="新增报价" :visible.sync="showDialog" append-to-body :close="onClose">

      <template #title>
        <span style="font-size:16px;font-weight:bold">新增报价</span>
        <span style="margin-left:20px" v-show="total">总费用：{{  total  }}</span>
      </template>

      <el-form ref="formDataRef" :model="formData" label-width="110px" inline :rules="rules" size="small">
        <el-form-item label="运输方式" prop="transportMethod">
          <plt-dict-select namespace="logistic" id="transportMethod" v-model="formData.transportMethod" size="small" style="width:180px" :exclusion="['express']" />
        </el-form-item>
        <el-form-item label="车辆类型" prop="vehicleId" v-if="formData.transportMethod==='FCL'" key="vehicleId">
          <plt-dict-select namespace="logistic" id="vehicleType" v-model="formData.vehicleId" size="small" style="width:180px" />
        </el-form-item>
        <el-form-item label="运费" prop="carriage">
          <el-input-number v-model="formData.carriage" :min="0" controls-position="right" style="width:180px"></el-input-number>
        </el-form-item>
        <el-form-item label="提货费" prop="pickUpFee">
          <el-input-number v-model="formData.pickUpFee" :min="0" controls-position="right" style="width:180px"></el-input-number>
        </el-form-item>
        <el-form-item label="配送费" prop="deliveryFee">
          <el-input-number v-model="formData.deliveryFee" :min="0" controls-position="right" style="width:180px"></el-input-number>
        </el-form-item><br>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="formData.remark" type="textarea" style="width:280px"></el-input>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="onClose" size="small">取消</el-button>
        <el-button type="primary" @click="onSubmit" size="small">确定</el-button>
      </template>

    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDialog: false,
      formData: {
        vehicleId: "",
        transportMethod: "",
        bidId: "",
        carriage: undefined,
        pickUpFee: 0,
        deliveryFee: 0,
        remark: ""
      },
      rules: {
        vehicleId: [{ required: true, message: "请选择" }],
        transportMethod: [{ required: true, message: "请选择" }],
        carriage: [{ required: true, message: "请输入" }],
        pickUpFee: [{ required: true, message: "请输入" }],
        deliveryFee: [{ required: true, message: "请输入" }]
      }
    };
  },
  computed: {
    total() {
      let sum = Number(Number(this.formData.carriage) + Number(this.formData.pickUpFee) + Number(this.formData.deliveryFee)).toFixed(2);
      return isNaN(sum) || sum == 0.0 ? "" : sum;
    }
  },
  watch: {
    "formData.transportMethod": function() {
      this.formData.vehicleId = "";
    }
  },
  methods: {
    openDialog(id) {
      this.formData.bidId = id;
      this.showDialog = true;
    },
    onClose() {
      this.showDialog = false;
      this.$refs["formDataRef"].resetFields();
    },
    async onSubmit() {
      let validate = await this.$refs["formDataRef"].validate();
      if (!validate) return;

      let url = "http://MID-OPERATE-LOGISTICS/messageService/logisticsInquiryTaskService/logisticMemberOfferQuotation";

      this.cfmInvoke(url, { quote: this.formData }).then((res) => {
        this.$message.success("操作成功");
        this.onClose();
        this.$emit("onFinish");
      });
    }
  }
};
</script>